import axios from "axios";


export const addPayment = async (bookingId, data) => {
    const url = `/api/v1/user_profile/bms/bookings/${bookingId}/booking_finance/payments`;
    const result = await axios.post(url, data);
    return result.data;
}


export const deletePayment = async (bookingId, paymentId) => {
    const url = `/api/v1/user_profile/bms/bookings/${bookingId}/booking_finance/payments/${paymentId}`;
    const result = await axios.delete(url);
    return result.data;
}

export const updateBookingFinance = async (bookingId, data) => {
    const url = `/api/v1/user_profile/bms/bookings/${bookingId}/booking_finance`;
    const result = await axios.put(url, data);
    return result.data;
}

export const createBookingFinanceDocument = async (bookingId) => {
    const url = `/api/v1/user_profile/bms/bookings/${bookingId}/booking_finance/booking_finance_document`;
    const result = await axios.post(url);
    return result.data;
}

export const getBookingFinanceDocument = async (bookingId) => {
    const url = `/api/v1/user_profile/bms/bookings/${bookingId}/booking_finance/booking_finance_document`;
    const result = await axios.get(url);
    return result.data;
}